<template>
  <el-dialog
    title="充值详情"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    @close="handleClose">
    <el-form label-width="140px" size="small" class="detail-form" v-loading="loading">
      <div class="formTitle">充值信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="交易订单号">
            <span>{{ detailData.outTradeNo }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发起支付时间">
            <span>{{ detailData.created | filterTime }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="充值金额">
            <span style="color: #67C23A; font-weight: bold; font-size: 16px;">¥{{ detailData.amount | filterMoney }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="支付状态">
            <el-tag :type="getRechargeStatusType(detailData.status)">
              {{ detailData.status | filterConst('CHANNEL_RECHARGE_STATUS') }}
            </el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="detailData.status === 2">
        <el-col :span="12">
          <el-form-item label="支付成功时间">
            <span>{{ detailData.callbackTime | filterTime }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="formTitle">渠道信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="渠道编号">
            <span>{{ detailData.channelNo }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="渠道名称">
            <span>{{ detailData.channelName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'RechargeDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rechargeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      detailData: {
        channelNo: '',
        channelName: '',
        outTradeNo: '',
        amount: 0,
        status: null,
        callbackTime: null,
        created: null
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.rechargeId) {
        this.loadDetail()
      }
    },
    rechargeId(val) {
      if (val && this.visible) {
        this.loadDetail()
      }
    }
  },
  methods: {
    /**
     * 获取充值详情
     * 使用接口：GET /api/v1/channel/recharge/detail
     * 作者：智慧云行
     */
    async loadDetail() {
      if (!this.rechargeId) {
        return
      }
      
      this.loading = true
      try {
        const res = await this.$axios.get('/api/v1/channel/recharge/detail', { id: this.rechargeId })
        if (res && res.code === 1 && res.data) {
          const detail = res.data
          // 字段映射
          this.detailData = {
            channelNo: detail.channelNo || '',
            channelName: detail.channelName || '',
            outTradeNo: detail.outTradeNo || '',
            amount: detail.amount || 0,
            status: detail.status || null,
            callbackTime: detail.callbackTime || null,
            created: detail.created || null
          }
        }
      } catch (error) {
        console.error('获取充值详情失败:', error)
        this.$message.error('获取充值详情失败')
      } finally {
        this.loading = false
      }
    },
    /**
     * 获取充值状态类型
     * 作者：智慧云行
     */
    getRechargeStatusType(status) {
      if (status === 1) {
        return 'warning' // 支付中
      } else if (status === 2) {
        return 'success' // 支付成功
      }
      return ''
    },
    /**
     * 关闭对话框
     * 作者：智慧云行
     */
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../channel.less';

.detail-form {
  /deep/ .el-form-item {
    margin-bottom: 8px;
  }
  
  /deep/ .el-row {
    margin-bottom: 0;
  }
  
  /deep/ .formTitle {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  
  /deep/ .formTitle:first-child {
    margin-top: 0;
  }
}
</style>

